const swiperReviews = new Swiper('.reviews-2025--swiper', {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  allowTouchMove: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  }
});